import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
// import {
//     formatterTime
// } from '@/util/util'



export const paymentOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    printBtn: true,
    excelBtn: true,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: '100',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "应付款编号",
            prop: "number",
            type: "input",
        }, {
            label: "采购订单编号",
            prop: "purchaseNumber",
            type: "input",
        }, {
            label: "搜索",
            prop: "search",
            search: true,
            hide: true,
            type: "input",
            searchPlaceholder: "编号/账号/店铺名称/法人名称",
        }, {
            label: "账号",
            prop: "account",
            type: 'input'
        },
        {
            label: "店铺名称",
            prop: "shopName",
            type: "input",
            width: "110"
        },

        {
            label: "法人名称",
            prop: "name",
            width: "110",
            type: 'input',
        },
        {
            label: "应付款金额",
            prop: "money",
            // solt: true,
            type: 'input',
        },
        {
            label: "付款时间",
            prop: "payTime",
            type: "datetime",
            sortable: true,
            valueFormat: "timestamp",
            formatter: function (row, value, label, column) {
                if (row.payTime != 0) {
                    return row.payTime
                }
            },
            format: "yyyy-MM-dd HH:mm:ss",
            // search: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "采购时间",
            prop: "startDate_endDate",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            clearable: true,
            // search: true,
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                return formatterTime(row.startTime) + '至' + formatterTime(row.endTime)
            }
        }
    ]
};